import { render, staticRenderFns } from "./tabGeneral.vue?vue&type=template&id=4581b5da&scoped=true&"
import script from "./tabGeneral.vue?vue&type=script&lang=js&"
export * from "./tabGeneral.vue?vue&type=script&lang=js&"
import style0 from "./tabGeneral.vue?vue&type=style&index=0&id=4581b5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581b5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4581b5da')) {
      api.createRecord('4581b5da', component.options)
    } else {
      api.reload('4581b5da', component.options)
    }
    module.hot.accept("./tabGeneral.vue?vue&type=template&id=4581b5da&scoped=true&", function () {
      api.rerender('4581b5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral.vue"
export default component.exports